import { useEffect, useState } from "react";

export function useResponsiveHeight({
  mobileOffset = 420,
  tabletOffset = 390,
  desktopOffset = 380,
  breakpoint = 768,
  tabletBreakpoint = 1024,
} = {}) {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);
  const [adjustedHeight, setAdjustedHeight] = useState(
    window.innerHeight - desktopOffset,
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;

      setWidth(w);
      setHeight(h);
      setIsMobile(w <= breakpoint);

      let offset = desktopOffset;
      if (w < breakpoint) {
        offset = mobileOffset;
      } else if (w >= breakpoint && w < tabletBreakpoint) {
        offset = tabletOffset;
      }

      setAdjustedHeight(h - offset);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint, tabletBreakpoint, mobileOffset, tabletOffset, desktopOffset]);

  return { adjustedHeight, height, width, isMobile };
}
